import { render } from "./Q3Detaille.vue?vue&type=template&id=081489d0"
import script from "./Q3Detaille.vue?vue&type=script&lang=js"
export * from "./Q3Detaille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__